import {computed, defineComponent} from 'vue'

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlOlMapInfo',
    props: {
        tagName: {
            type: String,
            default: 'p'
        }
    },
    setup() {
        const classes = computed(() => {
            return ['kl-ol-map-info']
        })
        return {
            classes
        }
    }
})
